<template>
  <div>
    <div class="Topic-title">基础通信 Topic 列表</div>
    <div>
      <vxe-table
        row-id="id"
        :data="table"
        :sort-config="{ defaultSort: { field: 'topic_use', order: 'asc' } }"
        align="left"
      >
        <vxe-table-column
          sortable
          field="topic_use"
          show-overflow
          min-width="50"
          title="功能"
        ></vxe-table-column>
        <vxe-table-column
          field="topic"
          show-overflow
          min-width="420"
          title="Topic"
        ></vxe-table-column>
        <vxe-table-column
          field="topic_power"
          show-overflow
          min-width="80"
          title="操作权限"
        ></vxe-table-column>
        <vxe-table-column
          field="topic_desc"
          show-overflow
          min-width="220"
          title="描述"
        ></vxe-table-column>
        <vxe-column title="操作" min-width="140">
          <template v-slot="slotProps">
            <span class="handle-button">
              <v-button
                size="S"
                type="text"
                name="btn1"
                slot="reference"
                @click="openViewModel(slotProps.row, 2)"
              >
                查看
              </v-button>
            </span>
          </template>
        </vxe-column>
      </vxe-table>

      <UpdataAndview
        :showInputDialog.sync="UpdataAndviewloading"
        ref="UpdataAndview"
        :id="id"
        :category="category"
        @getData="getData"
      ></UpdataAndview>
    </div>
  </div>
</template>

<script>
import UpdataAndview from "@/components/product/topic-list/view-params.vue";
import { BASE_TOPIC_TYPE, PUB_SUB } from "@/common/libs/Contains";

export default {
  components: {
    UpdataAndview,
  },
  props: {
    productKey: {},
  },
  data() {
    return {
      id: "",
      category: "",
      UpdataAndviewloading: false,
      table: [],
    };
  },
  created() {
    this.getData();
  },

  methods: {
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        product_key: this.productKey,
        topic_type: "base",
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/product/topic/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.table = res.data;
        this.table.map((item) => {
          item.topic_use = BASE_TOPIC_TYPE[item.topic_use];
          item.topic_power = PUB_SUB[item.topic_power];
        });
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    openViewModel(row) {
      this.id = row.topic_id;
      this.category = row.topic_power === PUB_SUB.sub ? 'input' : 'output';
      this.UpdataAndviewloading = !this.UpdataAndviewloading;
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
